/* Espaço das Calhas — Premium UX enhancements */

(function () {
  'use strict';

  /* ── Sticky header shadow ── */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) {
        header.style.boxShadow = '0 2px 16px rgba(0,0,0,0.22)';
      } else {
        header.style.boxShadow = '';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Scroll reveal para seções customizadas ── */
  var revealSelectors = [
    '.edc-sobre',
    '.edc-aval',
    '.edc-faq',
    '.edc-cta-dark',
    '.edc-loc',
    '.edc-breadcrumb'
  ];

  var revealEls = document.querySelectorAll(revealSelectors.join(','));

  if (revealEls.length && 'IntersectionObserver' in window) {
    revealEls.forEach(function (el) {
      el.classList.add('edc-reveal');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('edc-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  }

})();
